import { motion } from "framer-motion";
import styles from "./BookingPolicy.module.css";

const BookingPolicy = () => {
  const fadeVariant = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -10 },
  };

  return (
    <motion.main
      className={styles.bookingPolicy}
      variants={fadeVariant}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <section className={styles.inner}>
        <header className={styles.header}>
          <p className={styles.kicker}>Important Info</p>
          <h1 className={styles.title}>Tattoo Policies &amp; Booking Info</h1>
        </header>
        {/* Booking your appointment */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Booking Your Appointment</h2>
          <p className={styles.bodyText}>
            Once I receive your booking request, I’ll follow up with my next
            available appointment dates and request a{" "}
            <strong>non-refundable $100 deposit</strong> to secure your spot.
            Your appointment is <strong>not</strong> booked until the deposit is
            received.
          </p>
          <p className={styles.bodyText}>
            The $100 deposit will be applied toward the total cost of your
            tattoo on the day of your appointment.
          </p>
          <div className={styles.paymentBox}>
            <h3 className={styles.paymentTitle}>Deposit Payment Options</h3>
            <ul className={styles.paymentList}>
              <li>
                <span className={styles.paymentLabel}>Venmo:</span>{" "}
                <a
                  className={styles.paymentLink}
                  href="https://venmo.com/u/marlenatat2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @marlenatat2
                </a>
              </li>
              <li>
                <span className={styles.paymentLabel}>Cash App:</span>{" "}
                <a
                  className={styles.paymentLink}
                  href="https://cash.app/$marlenatat2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  $marlenatat2
                </a>
              </li>
            </ul>
            <p className={styles.helperText}>
              In the payment subject line, please include{" "}
              <strong>your first &amp; last name</strong> and your{" "}
              <strong>desired appointment time</strong>.
            </p>
          </div>
        </section>
        {/* Rescheduling / Cancellation */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>
            Rescheduling &amp; Cancellation
          </h2>
          <p className={styles.bodyText}>
            Please give a minimum of <strong>24 hours notice</strong> if you are
            sick or otherwise unable to make your appointment. With adequate
            notice, I’m happy to reschedule your appointment.
          </p>
          <p className={styles.bodyText}>
            If you <strong>do not show up</strong> for your appointment or{" "}
            <strong>fail to give 24 hours notice</strong> before rescheduling,
            your <strong>deposit is forfeited</strong> to compensate for my
            time.
          </p>
          <p className={styles.bodyText}>
            Each appointment can be rescheduled <strong>once</strong> without forfeiting your
            deposit. If you need to reschedule more than once another deposit
            will be needed.
          </p>
        </section>
        {/* Preparing for your appointment */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>
            Preparing for Your Appointment
          </h2>
          <ul className={styles.list}>
            <li>Arrive well hydrated and have a good meal beforehand.</li>
            <li>
              Wear <strong>comfortable, appropriate clothing</strong> that makes
              it easy to access the area being tattooed.
            </li>
            <li>
              You are welcome to bring a guest, but please note that space in
              the tattoo rooms is limited. Guests are welcome to sit in the
              lobby.
            </li>
          </ul>
          <p className={styles.bodyText}>
            <strong>Payment:</strong> Cash is always preferred, but I also
            accept Venmo and Cash App.
          </p>
        </section>
        {/* Tattoo designs */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Tattoo Designs</h2>
          <p className={styles.bodyText}>
            I generally <strong>do not send out designs</strong> prior to the
            appointment. I always factor in additional time at the start of your
            session to review the design together and make any necessary edits.
          </p>
          <p className={styles.bodyText}>
            If you <strong>would like to see the design ahead of time</strong>,
            please make specific arrangements with me in advance.
          </p>
        </section>
        {/* Location / Getting here */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Location &amp; Getting Here</h2>
          <p className={styles.bodyText}>
            I currently tattoo out of <strong>Holy Fool Tattoo Club</strong> in
            the North Valley.
          </p>
          <div className={styles.locationBox}>
            <p className={styles.bodyText}>
              <strong>Address: </strong>
              <a
                href="https://www.google.com/maps/search/?api=1&query=3716+Arno+NE+Suite+C+Albuquerque+NM+87107"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.addressLink}
              >
                <strong>3716 Arno NE, Suite C</strong>
              </a>
            </p>
            <p className={styles.bodyText}>
              The studio is in a complex behind a white fence on the corner of{" "}
              <strong>Candelaria &amp; Arno</strong>.
            </p>
            <p className={styles.bodyText}>
              If you’re having trouble finding us, route your maps to{" "}
              <a
                href="https://www.google.com/maps/search/?api=1&query=325+Candelaria+Rd+NE+B+Albuquerque+NM+87107"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.addressLink}
              >
                <strong>The Painted Pony Shoppe{" "}</strong>
              </a>
              — our studio is just around the corner.
            </p>
          </div>
        </section>
        {/* Contact */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Contact</h2>
          <p className={styles.bodyText}>
            The best way to reach me is by email at:
          </p>
          <p className={styles.email}>
            <a href="mailto:Marlena.mendoza.art@gmail.com">
              <strong>Marlena.mendoza.art@gmail.com</strong>
            </a>
          </p>
        </section>
      </section>
    </motion.main>
  );
};

export default BookingPolicy;
